import { render } from "./VoiceRecorder.vue?vue&type=template&id=0b9ee1e1&scoped=true"
import script from "./VoiceRecorder.vue?vue&type=script&lang=js"
export * from "./VoiceRecorder.vue?vue&type=script&lang=js"

import "./VoiceRecorder.vue?vue&type=style&index=0&id=0b9ee1e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9ee1e1"]])

export default __exports__